import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import { ReactComponent as EditSvg } from './assets/edit.svg';

const EditIcon = React.forwardRef((args, ref) => <SvgIcon component={EditSvg} ref={ref} {...args} />);

export default EditIcon;
